module.exports = __webpack_public_path__ + "img/curtis.7365cc89.png";